export enum UserBalanceOperations {
  INCREASE = 'increase',
  DECREASE = 'decrease',
}
